import { mapState } from "vuex";
import { Component, Vue } from "vue-property-decorator";
import { IState } from "@/store";
import { IBrand } from "@/models/brands";
import { UUID } from "@/data/enums";

@Component({
  computed: {
    ...mapState({
      brandId: (state: IState) => state.auth.admin.brandId
    })
  }
})
export default class AdminBrandId extends Vue {
  // getters
  public brandId!: IBrand["id"];

  public get isOrgMode() {
    return this.brandId === UUID.ORG;
  }
}
